import { css as t, styled as i, excludeProps as s, variants as b } from "@lokalise/styled";
import { value as o, typography as p } from "../../utils/theme/index.js";
const r = t`
	top: -5px;

	&::before {
		border-left-width: 1px;
		border-left-style: solid;
		border-top-width: 1px;
		border-top-style: solid;
	}
`, e = t`
	bottom: -5px;

	&::before {
		border-right-width: 1px;
		border-right-style: solid;
		border-bottom-width: 1px;
		border-bottom-style: solid;
	}
`, d = t`
	right: -5px;

	&::before {
		border-right-width: 1px;
		border-right-style: solid;
		border-top-width: 1px;
		border-top-style: solid;
	}
`, l = t`
	left: -5px;

	&::before {
		border-left-width: 1px;
		border-left-style: solid;
		border-bottom-width: 1px;
		border-bottom-style: solid;
	}
`, h = i.div.withConfig({ shouldForwardProp: s(["placement"]) })`
	position: absolute;
	width: 8px;
	height: 8px;
	z-index: ${o("zIndex.hide")};

	&::before {
		position: absolute;
		width: 8px;
		height: 8px;
		z-index: ${o("zIndex.hide")};
		content: '';
		display: block;
		transform: rotate(45deg);
		background-color: ${o("color.background.surface.default")};
		border-color: ${o("color.border.default")};
	}

	${b(
  "placement",
  {
    top: e,
    bottom: r,
    left: d,
    right: l,
    "right-end": l,
    "right-start": l,
    "left-start": d,
    "auto-end": t``,
    "auto-start": t``,
    auto: t``,
    "bottom-end": r,
    "bottom-start": r,
    "left-end": d,
    "top-end": e,
    "top-start": e
  },
  "auto"
)}
`, x = i.div`
	padding: 0;
	border-radius: ${o("radius.tooltip")};
	background-color: ${o("color.background.surface.default")};
	border: 1px solid ${o("color.border.default")};
	box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
	z-index: ${o("zIndex.popover")};
	color: ${o("color.text.default")};
	${p("body.small.default")};
	width: max-content;
`;
export {
  h as Arrow,
  x as Content
};
//# sourceMappingURL=styles.js.map
